import { render } from "./FormCreateTicket.vue?vue&type=template&id=5c50e587&scoped=true&ts=true"
import script from "./FormCreateTicket.vue?vue&type=script&lang=ts"
export * from "./FormCreateTicket.vue?vue&type=script&lang=ts"

import "./FormCreateTicket.vue?vue&type=style&index=0&id=5c50e587&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c50e587"]])

export default __exports__